import { Formik } from "formik";
import {
  HeaderSaveFormButton,
  EfsMelcoEfsModelsFormat,
} from "melco-shared-logic";
import {
  InputFormatDetailFormValueType,
  useInputFormatFormSubmit,
} from "../../hooks/inputFormats/useInputFormatFormSubmit";
import { DirtyFormPrompt } from "../form/DirtyFormPrompt";
import { DisplayInputFormatDetailForm } from "./DisplayInputFormatDetailForm";

type InputFormatDetailFormProps = {
  inputFormat: EfsMelcoEfsModelsFormat;
};

export const inputFormatToInitialValues = (
  inputFormat: EfsMelcoEfsModelsFormat
) => {
  const {
    id,
    key,
    display_name,
    xml_orders_xpath,
    unique_field,
    headers,
    type,
    schema_list,
    filename_rules_list,
  } = inputFormat;

  const initialValues: InputFormatDetailFormValueType = {
    id: id ?? "",
    key: key ?? "",
    display_name: display_name ?? "",
    xml_orders_xpath: xml_orders_xpath ?? undefined,
    unique_field: unique_field ?? undefined,
    headers: headers ?? undefined,
    type: type ?? "",
    schema_list: schema_list ?? [],
    filename_rules_list: filename_rules_list ?? [],
  };

  return initialValues;
};

export const InputFormatDetailForm: React.FC<InputFormatDetailFormProps> = ({
  inputFormat,
}) => {
  const onSubmit = useInputFormatFormSubmit();

  const initialValues = inputFormatToInitialValues(inputFormat);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <DirtyFormPrompt>
        <DisplayInputFormatDetailForm inputFormat={inputFormat} />
        <HeaderSaveFormButton />
      </DirtyFormPrompt>
    </Formik>
  );
};
